import SearchableDropdown from "components/DropDown/SearchableDropdown";
import StatusToggle from "components/ToggleButton/StatusToggle";
import React, { useState } from "react";
import "react-select2-wrapper/css/select2.css";
import { MAX_FILE_SIZE } from "variables/constants";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
  FormFeedback,
} from "reactstrap";
import TagInputSection from "./TagInputSection";
import MultiSelectDropDown from "components/DropDown/MultiselectDropDown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DealTagInputSection from "./DealTagInputSection";

const DynamicFormModal = ({
  isOpen,
  toggle,
  title,
  fields,
  formData,
  errors = {},
  onChange,
  onSubmit,
  showDocumentUpload = false,
  formState,
  setFormState,
  isCsv = false,
  isEditMode,
  trueLabel,
  falseLabel,
  siteNames = { show: false, error: "" },
  bundleIds = { show: false, error: "" },
  onSearch,
  onLoadMore,
  tagError = "",
  hasMore,
  showLoader = false,
  previousDealDates = [],
}) => {
  const [showPreviousDates, setShowPreviousDates] = useState(false);
  const normalFields = fields?.filter((f) => f.type !== "toggle");
  const toggleFields = fields?.filter(
    (f) => f.type === "toggle" && f.showToogleatEnd == true,
  );
  const checkFields = fields?.filter((f) => f.type === "checkbox");
  
  const getDocTypeFromName = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    if (ext === "pdf") return "pdf";
    if (ext === "doc" || ext === "docx") return "doc";
    return "unknown";
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDocumentChange = (file) => {
    // Call parent's onChange to update formData
    if (onChange) {
      onChange("document", file, "file");
    }
    
    // Also update local formState for UI
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        document: file,
        documentPreview: null,
      },
      errors: {
        ...prev.errors,
        document: null,
      },
    }));
  };

  // ✅ FIXED: Update both parent and local state
  const handleCSVFileChange = (file) => {
    // Call parent's onChange to update formData
    if (onChange) {
      onChange("csvFile", file, "file");
    }
    
    // Also update local formState for UI
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        csvFile: file,
      },
      errors: {
        ...prev.errors,
        csvFile: null,
      },
    }));
  };

  const renderDocumentUpload = () => (
    <FormGroup className="d-flex flex-column align-items-start mb-1">
      <Label>
        Upload Document
        <span className="text-muted ml-1">
          <span className="text-danger mr-1">*</span>(PDF / DOC / DOCX • Max 10
          MB)
        </span>
      </Label>

      <div
        className={`product-image-upload w-100 p-3 rounded text-center ${formState.errors?.document ? "border border-warning" : "border"
          }`}
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          const file = e.dataTransfer.files[0];
          if (!file) return;

          const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ];

          if (!allowedTypes.includes(file.type)) return;

          if (file.size > MAX_FILE_SIZE) {
            setFormState((prev) => ({
              ...prev,
              errors: {
                ...prev.errors,
                document: "Document size should not exceed 10 MB",
              },
            }));
            return;
          }

          handleDocumentChange(file);
        }}
      >
        {formState?.values?.document?.name ? (
          <div className="border rounded p-3">
            <div className="d-flex flex-column align-items-start">
              <div className="d-flex align-items-start">
                {getDocTypeFromName(formState.values.document.name) ===
                  "pdf" ? (
                  <i className="fa fa-file-pdf text-danger fa-4x mb-2 ml-4" />
                ) : (
                  <i className="fa fa-file-word text-primary fa-4x mb-2 ml-4" />
                )}

                <span
                  className="text-danger pointer ml-2"
                  onClick={() => {
                    if (onChange) {
                      onChange("document", null, "file");
                    }
                    setFormState((prev) => ({
                      ...prev,
                      values: { ...prev.values, document: null },
                    }));
                  }}
                >
                  <i className="fa fa-times" />
                </span>
              </div>

              <p className="mb-2">{formState.values.document.name}</p>

              {formState.values.document.mediaPath && (
                <div className="d-flex align-items-center">
                  <span
                    className="text-info pointer mr-3"
                    onClick={() =>
                      window.open(formState.values.document.mediaPath, "_blank")
                    }
                  >
                    <i className={`fa fa-eye ${isEditMode ? "" : "ml-5"}`} />
                  </span>

                  {isEditMode && (
                    <span
                      className="text-info pointer"
                      onClick={() => {
                        const a = document.createElement("a");
                        a.href = formState.values.document.mediaPath;
                        a.download = formState.values.document.name;
                        a.click();
                      }}
                    >
                      <i className="fa fa-download ml-5" />
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <i className="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
            <p className="mb-1 text-muted">Click or drag document to upload</p>
            <Label for="ioDocumentInput" className="btn btn-simple btn-sm mt-2">
              Choose Document
            </Label>
          </div>
        )}

        <Input
          type="file"
          accept=".pdf,.doc,.docx"
          className="d-none"
          id="ioDocumentInput"
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (file.size > MAX_FILE_SIZE) {
              setFormState((prev) => ({
                ...prev,
                errors: {
                  ...prev.errors,
                  document: "Document size should not exceed 10 MB",
                },
              }));
              return;
            }

            handleDocumentChange(file);
            e.target.value = "";
          }}
        />
      </div>

      {formState.errors?.document && (
        <small style={{ color: "#fb6340", marginTop: 1 }}>
          {formState.errors.document}
        </small>
      )}
    </FormGroup>
  );

  // ✅ FIXED: Updated renderCSVUpload to properly handle onChange
  const renderCSVUpload = () => {
    // Get the current file from either formState or formData
    const currentFile = formState?.values?.csvFile || formData?.csvFile;
    
    return (
      <FormGroup className="d-flex flex-column align-items-start mb-1">
        <Label>
          Upload CSV File
          <span className="text-muted ml-1">
            <span className="text-danger mr-1">*</span>(CSV • Max 10 MB)
          </span>
        </Label>

        <div
          className={`product-image-upload w-100 p-3 rounded text-center ${formState.errors?.csvFile ? "border border-warning" : "border"
            }`}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            if (!file) return;

            // Check if file is CSV
            if (!file.name?.toLowerCase().endsWith('.csv')) {
              setFormState((prev) => ({
                ...prev,
                errors: {
                  ...prev.errors,
                  csvFile: "Only CSV files are allowed",
                },
              }));
              return;
            }

            if (file.size > MAX_FILE_SIZE) {
              setFormState((prev) => ({
                ...prev,
                errors: {
                  ...prev.errors,
                  csvFile: "File size should not exceed 10 MB",
                },
              }));
              return;
            }

            handleCSVFileChange(file);
          }}
        >
          {currentFile?.name ? (
            <div className="border rounded p-3">
              <div className="d-flex flex-column align-items-start">
                <div className="d-flex align-items-start w-100 justify-content-between">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-file-excel text-success fa-4x mb-2" />
                    <div className="ml-3">
                      <p className="mb-1 font-weight-bold">{currentFile.name}</p>
                      <small className="text-muted">
                        {(currentFile.size / 1024).toFixed(2)} KB
                      </small>
                    </div>
                  </div>

                  <span
                    className="text-danger pointer"
                    onClick={() => {
                      // Clear file from both parent and local state
                      if (onChange) {
                        onChange("csvFile", null, "file");
                      }
                      setFormState((prev) => ({
                        ...prev,
                        values: { ...prev.values, csvFile: null },
                        errors: { ...prev.errors, csvFile: null },
                      }));
                    }}
                  >
                    <i className="fa fa-times-circle fa-lg" />
                  </span>
                </div>

                {currentFile.mediaPath && (
                  <div className="d-flex align-items-center mt-3">
                    <span
                      className="text-info pointer mr-3"
                      onClick={() =>
                        window.open(currentFile.mediaPath, "_blank")
                      }
                    >
                      <i className="fa fa-eye mr-1" /> View
                    </span>

                    {isEditMode && (
                      <span
                        className="text-info pointer"
                        onClick={() => {
                          const a = document.createElement("a");
                          a.href = currentFile.mediaPath;
                          a.download = currentFile.name;
                          a.click();
                        }}
                      >
                        <i className="fa fa-download mr-1" /> Download
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center">
              <i className="fa fa-file-excel-o text-success fa-3x mb-2"></i>
              <i className="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
              <p className="mb-1 text-muted small">Only .csv files are allowed</p>
              <Label htmlFor="csvFileInput" className="btn btn-simple btn-sm mt-2">
                Choose CSV File
              </Label>
            </div>
          )}

          <Input
            type="file"
            accept=".csv"
            className="d-none"
            id="csvFileInput"
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              // Check if file is CSV
              if (!file.name?.toLowerCase().endsWith('.csv')) {
                setFormState((prev) => ({
                  ...prev,
                  errors: {
                    ...prev.errors,
                    csvFile: "Only CSV files are allowed",
                  },
                }));
                e.target.value = "";
                return;
              }

              if (file.size > MAX_FILE_SIZE) {
                setFormState((prev) => ({
                  ...prev,
                  errors: {
                    ...prev.errors,
                    csvFile: "File size should not exceed 10 MB",
                  },
                }));
                e.target.value = "";
                return;
              }

              handleCSVFileChange(file);
              e.target.value = "";
            }}
          />
        </div>

        {formState.errors?.csvFile && (
          <small style={{ color: "#fb6340", marginTop: 5 }}>
            {formState.errors.csvFile}
          </small>
        )}
      </FormGroup>
    );
  };

  const modalStyles = {
    header: {
      borderBottom: "2px solid #f0f0f0",
      paddingBottom: "18px",
      paddingTop: "18px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "700",
      color: "#2c3e50",
      letterSpacing: "0.3px",
    },
    body: {
      padding: "24px",
      maxHeight: "calc(100vh - 200px)",
      overflowY: "auto",
    },
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <Form onSubmit={onSubmit}>
        <ModalHeader toggle={toggle} style={modalStyles.header}>
          <h5 style={modalStyles.title}>{title}</h5>
        </ModalHeader>

        <ModalBody style={modalStyles.body}>
          {/* 🔹 FORM FIELDS */}
          <Row className="g-3">
            {fields
              .filter((field) => {
                // No condition → show
                if (!field.showWhen) return true;

                const { field: dependsOn, equals } = field.showWhen;
                const dependentValue = formData?.[dependsOn];

                if (Array.isArray(equals)) {
                  return equals.includes(dependentValue);
                }

                return dependentValue === equals;
              })
              .map((field, index) => (
                <React.Fragment key={index}>
                  <Col
                    md={field.colSize || 6}
                  >
                    <FormGroup>
                      {field.type !== "toggle" &&
                        field.type !== "checkbox" &&
                        field.type !== "section" &&
                        field?.type !== "divider" &&
                        field.type !== "date" &&
                        field.type !== "dropdown-input" && (
                          <Label style={modalStyles.label}>
                            {field.label}
                            {field.required && (
                              <span className="text-danger ml-1" style={{ fontSize: "16px" }}>*</span>
                            )}
                          </Label>
                        )}
                      {/* Sub Card Header */}
                      {field.type === "section" && (
                        <>
                          <hr className="mt-2 mb-2" />
                          <h3 className="form-section-title font-weight-600">
                            {field.title}
                          </h3>
                          {tagError !== "" && title === "Edit Deal" && (
                            <p className="text-danger ">{tagError}</p>
                          )}

                          {field.description && (
                            <p className="text-muted ">{field.description}</p>
                          )}
                        </>
                      )}
                      {/* Divider Code */}
                      {field?.type === "divider" && (
                        <hr className="mt-2 mb-3" />
                      )}
                      {/* DROPDOWN */}
                      {field.type === "dropdown" ? (
                        <SearchableDropdown
                          name={field.name}
                          options={field.options}
                          value={formData[field.name] || ""}
                          placeholder={field.placeholder}
                          isSearchable={field.isSearchable}
                          onChange={onChange}
                          error={errors[field.name]}
                          onSearch={onSearch}
                          onLoadMore={onLoadMore}
                          hasMore={field.hasMore}
                          disabled={field.disabled}
                        />
                      ) : field.type === "MultiSelectDropdown" ? (
                        <MultiSelectDropDown
                          name={field.name}
                          options={field.options}
                          value={formData[field.name] || ""}
                          placeholder={field.placeholder}
                          isSearchable={field.isSearchable}
                          onChange={onChange}
                          error={errors[field.name]}
                          isMulti={field.isMulti}
                        />
                      ) : field.type === "toggle" &&
                        field?.showToogleatEnd === false ? (
                        <div className="d-flex flex-column">
                          <Label>{field.label}</Label>
                          <StatusToggle
                            name={field.name}
                            value={formData[field.name]}
                            onChange={onChange}
                            trueLabel={trueLabel}
                            falseLabel={falseLabel}
                          />
                        </div>
                      ) : field.type === "date" ? (
                        <div className="w-100 position-relative">
                          <Label>
                            {field.label}
                            {field.required && (
                              <span className="text-danger ml-1">*</span>
                            )}
                          </Label>
                          <DatePicker
                            selected={
                              formData[field.name]
                                ? new Date(formData[field.name])
                                : null
                            }
                            onChange={(date) =>
                              onChange({
                                target: {
                                  name: field.name,
                                  value: date ? formatDate(date) : "",
                                },
                              })
                            }
                            dateFormat="dd MMM yyyy"
                            placeholderText={field.placeholder}
                            className={`form-control w-100 custom-datepicker ${errors[field.name] ? "is-invalid" : ""
                              }`}
                            disabled={
                              field.disabled ||
                              (field.dependsOn && !formData[field.dependsOn])
                            }
                            minDate={
                              field.dependsOn
                                ? formData[field.dependsOn]
                                  ? new Date(formData[field.dependsOn])
                                  : undefined
                                : field.min
                                  ? new Date(field.min)
                                  : undefined
                            }
                            maxDate={
                              field.max ? new Date(field.max) : undefined
                            }
                            popperProps={{
                              strategy: "fixed"
                            }}
                          />
                          <i className="ni ni-calendar-grid-58 text-muted datepicker-icon" />
                          {errors[field.name] && (
                            <FormFeedback className="d-block">
                              {errors[field.name]}
                            </FormFeedback>
                          )}
                        </div>
                      ) : field.type === "dropdown-input" ? (
                        <>
                          <Label>
                            {field.label}
                            {field.required && (
                              <span className="text-danger ml-1">*</span>
                            )}
                          </Label>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div style={{ width: field.dropdownWidth || "40%" }}>
                              <SearchableDropdown
                                name={field.dropdownName}
                                options={field.dropdownOptions}
                                value={formData[field.dropdownName] || ""}
                                placeholder={field.dropdownPlaceholder || "Select"}
                                isSearchable={field.isSearchable}
                                onChange={onChange}
                                error={errors[field.dropdownName]}
                                onSearch={onSearch}
                                onLoadMore={onLoadMore}
                                hasMore={field.hasMore}
                                disabled={field.disabled}
                              />
                            </div>
                            <div style={{ width: field.inputWidth || "60%" }}>
                              <Input
                                type={field.inputType || "text"}
                                name={field.inputName}
                                value={formData[field.inputName] || ""}
                                placeholder={field.inputPlaceholder}
                                onChange={onChange}
                                invalid={!!errors[field.inputName]}
                                autoComplete="off"
                                disabled={
                                  field.disabled ||
                                  (field.dependsOn && !formData[field.dependsOn])
                                }
                              />
                              {errors[field.inputName] && (
                                <FormFeedback className="d-block">
                                  {errors[field.inputName]}
                                </FormFeedback>
                              )}
                            </div>
                          </div>
                        </>
                      ) : field.type === "text" ||
                        field.type === "textarea" ||
                        field.type === "number" ||
                        field.type === "email" ? (
                        <>
                          {/* NORMAL INPUT */}
                          <Input
                            type={field.type}
                            name={field.name}
                            value={formData[field.name]}
                            placeholder={field.placeholder}
                            onChange={(e) => {
                              onChange(e);
                            }}
                            invalid={!!errors[field.name]}
                            autoComplete="off"
                            min={
                              field.dependsOn
                                ? formData[field.dependsOn] || undefined
                                : field.min
                            }
                            max={field.max}
                            disabled={
                              field.disabled ||
                              (field.dependsOn && !formData[field.dependsOn])
                            }
                          />

                          {errors[field.name] && (
                            <FormFeedback>{errors[field.name]}</FormFeedback>
                          )}

                          {field.showCharCount && field.maxLength && (
                            <small className="text-muted d-block">
                              {(formData[field.name] || "").length}/
                              {field.maxLength} characters
                            </small>
                          )}
                        </>
                      ) : field.type === "checkbox" ? (
                        <Row md={12} >
                          <Col
                            md={6 || 6}
                            key={field.name}
                            className="mt-3"
                          >
                            <div className="d-flex flex-column ml-4">
                              <Label>
                                <Input
                                  type="checkbox"
                                  name={field.name}
                                  checked={formData[field.name] || false}
                                  onChange={(e) =>
                                    onChange({
                                      target: {
                                        name: field.name,
                                        value: e.target.checked,
                                      },
                                    })
                                  }
                                />
                                {title === "Create New Deal"
                                  ? field.label
                                  : title === "Edit Deal"
                                    ? tagError === ""
                                      ? "Update a tag"
                                      : field.label
                                    : field.label}
                              </Label>
                            </div>
                          </Col>
                          {isEditMode && (
                            <Col md={6}>
                              <Row className="mt-3">
                                <Col >
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="checkbox"
                                        name="showPreviousDealDates"
                                        checked={showPreviousDates}
                                        onChange={(e) => setShowPreviousDates(e.target.checked)}
                                      />
                                      {' '}
                                      Deal History Log
                                    </Label>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>
                      ) : field.type === "taginput" || field.type === "tagInput" ? (
                        <>
                          <DealTagInputSection
                            // label={field.label}
                            placeholder={field.placeholder}
                            valueKey={field.name}
                            badgeColor={field.badgeColor || "info"}
                            formState={formState}
                            setFormState={setFormState}
                            formData={formData}
                            onChange={onChange}
                            error={errors[field.name]}
                            plain={field.plain || false}
                          // objectKey={field.objectKey || "value"}
                          />
                        </>
                      ) : null}
                    </FormGroup>
                  </Col>

                  {field.breakAfter && <Col md="12" />}
                </React.Fragment>
              ))}
          </Row>

          {/* Previous Deal Dates Table */}
          {showPreviousDates && isEditMode && previousDealDates?.length > 0 && (
            <Row className="mt-3">
              <Col md={12} xs="12">
                <div style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  padding: "16px",
                  border: "1px solid #dee2e6"
                }}>
                  <h2>
                    Deal History Log
                  </h2>
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-striped" style={{ marginBottom: "0" }}>
                      <thead>
                        <tr>
                          <th style={{ backgroundColor: "#f8f9fa", fontWeight: "700", color: "#2c3e50", borderBottom: "2px solid #dee2e6", padding: "12px" }}>Start Date</th>
                          <th style={{ backgroundColor: "#f8f9fa", fontWeight: "700", color: "#2c3e50", borderBottom: "2px solid #dee2e6", padding: "12px" }}>End Date</th>
                          <th style={{ backgroundColor: "#f8f9fa", fontWeight: "700", color: "#2c3e50", borderBottom: "2px solid #dee2e6", padding: "12px" }}>Deal Type</th>
                          <th style={{ backgroundColor: "#f8f9fa", fontWeight: "700", color: "#2c3e50", borderBottom: "2px solid #dee2e6", padding: "12px" }}>Deal Type Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previousDealDates && previousDealDates.length > 0 ? (
                          previousDealDates.map((dateObj, idx) => (
                            <tr key={idx}>
                              <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>{dateObj?.startDate || "-"}</td>
                              <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>{dateObj?.endDate || "-"}</td>
                              <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>{dateObj?.dealType || "-"}</td>
                              <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>{dateObj?.dealTypeValue || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center" style={{ padding: "10px 12px" }}>
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {isEditMode && title === "Edit Deal" && (
            <Col md={12}>
              <Row className="mt-3">
                Note: On submit, the relevant data will be processed immediately.
              </Row>
            </Col>
          )}
          {showDocumentUpload == true && (
            <Row>
              <Col md="12">{isCsv ? renderCSVUpload() : renderDocumentUpload()}</Col>
            </Row>
          )}

          {siteNames?.show == true && (
            <Row>
              <Col md="12" xs="12">
                <TagInputSection
                  label="Site Names"
                  placeholder="Enter site name and press Enter"
                  valueKey="siteNames"
                  badgeColor="info"
                  formState={formState}
                  setFormState={setFormState}
                  error={siteNames?.error}
                // plain={formData}
                />
              </Col>
            </Row>
          )}

          {bundleIds?.show == true && (
            <Row>
              <Col md="12" xs="12">
                <TagInputSection
                  label="Bundle IDs"
                  placeholder="Enter bundle ID (e.g. com.app.name)"
                  valueKey="bundleIds"
                  badgeColor="warning"
                  formState={formState}
                  setFormState={setFormState}
                  error={bundleIds?.error}
                />
              </Col>
            </Row>
          )}

          {toggleFields.length > 0 && (
            <Row key={toggleFields.length}>
              {toggleFields
                .filter((field) => {
                  // No condition → show
                  if (!field.showWhen) return true;

                  const { field: dependsOn, equals } = field.showWhen;
                  const dependentValue = formData?.[dependsOn];

                  if (Array.isArray(equals)) {
                    return equals.includes(dependentValue);
                  }

                  return dependentValue === equals;
                })
                .map((field) => (
                  <React.Fragment key={field.name}>
                    <Col
                      md={field.colSize || 6}
                      className="mb-3"
                    >
                      <FormGroup className="mb-1">
                        <div className="d-flex flex-column mt-4">
                          <Label>{field.label}</Label>
                          <StatusToggle
                            name={field.name}
                            value={formData[field.name]}
                            onChange={onChange}
                            trueLabel={trueLabel}
                            falseLabel={falseLabel}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </React.Fragment>
                ))}
            </Row>
          )}

          {/* Previous Deal Dates: checkbox + table (edit mode only) */}
        </ModalBody>

        <ModalFooter>
          <Button
            type="submit"
            className="btn-gradient-primary btn-md"
            disabled={showLoader}
          >
            Submit {showLoader && <i className="fa fa-spinner fa-spin" />}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default DynamicFormModal;